"use client";

import { useTranslations } from "next-intl";
import { Control } from "react-hook-form";

import ImageUploader from "@/components/common/forms/ImageUploader";
import { SellCarFormSchemaType } from "@/schemas/validation/sellCarFormSchema";

interface SecondStepProps {
  control: Control<SellCarFormSchemaType>;
}

const SecondStep = ({ control }: SecondStepProps) => {
  const t = useTranslations("SellCar.images");
  const tCommon = useTranslations("Common.forms.imageUploader");
  const labels = Array(6).fill(tCommon("upload"));

  return (
    <div className="mt-10">
      <div className="mt-4">
        <ImageUploader
          name="images"
          control={control}
          required
          label={t("uploadLabel")}
          maxImages={6}
          s3FolderName="sell_car_requests"
          labels={labels}
        />
      </div>
    </div>
  );
};

export default SecondStep;
